(function(){
  // Elements
  const mainModal = document.getElementById('main-modal');
  const openMainModal = document.getElementById('open-main-modal');
  const videoModal = document.getElementById('video-modal');
  const videoEl = document.getElementById('video-player');

  const headerMobile = document.querySelector('.header__mobile');
  const headerDesktop = document.querySelector('.header__desktop');
  const themeHeader = document.querySelector('.theme__header');

  function setHeadersZ(z) {
    if (headerMobile) headerMobile.style.zIndex = z;
    if (headerDesktop) headerDesktop.style.zIndex = z;
    if (themeHeader) themeHeader.style.zIndex = z;
  }

  function openModal(modalEl){
    modalEl.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setHeadersZ('0');
  }

  function closeModal(modalEl){
    modalEl.classList.remove('is-open');
    document.body.style.overflow = 'auto';
    setHeadersZ('100');
  }

  // Size Guide open — primary button + any additional .open-main-modal-btn triggers
  if (openMainModal && mainModal) {
    openMainModal.addEventListener('click', () => {
      openModal(mainModal);
      openMainModal.setAttribute('aria-expanded', 'true');
    });
  }
  // Delegated listener — survives variant-selects re-rendering
  // When the size_guide_source toggle is 'page' (in size-selector.liquid), the
  // legacy #main-modal isn't rendered; instead a Broadcast <popup-component>
  // wraps an <a data-popup-open> trigger + a <dialog id="size-guide-modal">.
  // Route legacy .open-main-modal-btn clicks to whichever path is present.
  document.body.addEventListener('click', (e) => {
    const btn = e.target.closest('.open-main-modal-btn');
    if (!btn || btn === openMainModal) return;
    e.preventDefault();

    // Prefer the new page-based popup-component if it's present
    const popupTrigger = document.querySelector('.size-selector-heading popup-component [data-popup-open]');
    if (popupTrigger) {
      popupTrigger.click();
      return;
    }

    // Fall back to legacy class-toggled modal
    if (mainModal) openModal(mainModal);
  });

  // Close buttons (both modals)
  document.querySelectorAll('.closen').forEach(btn => {
    btn.addEventListener('click', () => {
      const which = btn.getAttribute('data-close');
      if (which === 'main' && mainModal) {
        closeModal(mainModal);
        if (openMainModal) openMainModal.setAttribute('aria-expanded', 'false');
      }
      if (which === 'video' && videoModal) {
        stopVideo();
        closeModal(videoModal);
      }
    });
  });

  // Click outside to close
  window.addEventListener('click', (evt) => {
    if (evt.target === mainModal) {
      closeModal(mainModal);
      if (openMainModal) openMainModal.setAttribute('aria-expanded', 'false');
    }
    if (evt.target === videoModal) {
      stopVideo();
      closeModal(videoModal);
    }
  });

  // ESC to close
  window.addEventListener('keydown', (evt) => {
    if (evt.key === 'Escape') {
      if (mainModal && mainModal.classList.contains('is-open')) {
        closeModal(mainModal);
        if (openMainModal) openMainModal.setAttribute('aria-expanded', 'false');
      }
      if (videoModal && videoModal.classList.contains('is-open')) {
        stopVideo();
        closeModal(videoModal);
      }
    }
  });

  // Wire up all Packing Video buttons using event delegation
  document.addEventListener('click', (evt) => {
    const btn = evt.target.closest('.video-btn');
    if (!btn) return;

    const src = btn.getAttribute('data-video');
    if (!src) return;

    // Load and play the MP4 in <video>
    if (videoEl) {
      // Reset any previous source
      stopVideo();

      videoEl.src = src;
      // Attempt autoplay (muted + playsinline improves success on mobile)
      const playPromise = videoEl.play();
      if (playPromise && typeof playPromise.then === 'function') {
        playPromise.catch(() => {
          // If autoplay blocked, just show controls; user can hit play
        });
      }
    }

    if (videoModal) openModal(videoModal);
  });

  function stopVideo(){
    if (!videoEl) return;
    try {
      videoEl.pause();
      // Clearing src fully stops download & frees decoder
      videoEl.removeAttribute('src');
      videoEl.load();
    } catch(e){}
  }
})();